//import ol from 'https://cdn.jsdelivr.net/npm/ol@v7.3.0/dist/ol.js';
import Map from 'ol/Map.js';
import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/Tile.js';
import TileWMS from 'ol/source/TileWMS.js';
import XYZ from 'ol/source/XYZ.js';
import View from 'ol/View.js';
import proj4 from 'https://cdn.jsdelivr.net/npm/proj4@2.7.5/+esm';
import {getCenter, getWidth} from 'ol/extent.js';
import {get as getProjection, transformExtent} from 'ol/proj.js';
import {Control, defaults as defaultControls} from 'ol/control.js';
import {getBottomLeft, getTopRight} from 'ol/extent.js';
import {toLonLat} from 'ol/proj.js';


import LayerGroup from 'ol/layer/Group';
import SourceStamen from 'ol/source/Stamen';

import {CustomLSW} from './classes/CustomLSW.js';
//import {getAvitoHtml, getLoadingHtml, setDescriptionEvents} from './helpers.js';
import {getJson} from './helpers.js';

import {getVectorContext} from 'ol/render.js';
import {unByKey} from 'ol/Observable.js';
import {easeOut} from 'ol/easing.js';
import {Circle as CircleStyle, Stroke, Style} from 'ol/style.js';

//import OLCesium from 'olcs/OLCesium.js';

import {MetroSPbLayer} from './classes/MetroSPbLayer.js';
import {SpotLayer} from './classes/SpotLayer.js';
import {AvitoLayer} from './classes/AvitoLayer.js';

import {ServiceControl} from './classes/ServiceControl.js';


//const svgArrowDown = '<svg width="120" height="120" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx="60" cy="60" r="60"/></svg>';

//================= AUTH =================
const getParams = (new URL(document.location)).searchParams; 
const appMK = getParams.get("mk");
const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:5000/api?';
const proxyURL = API_BASE + (appMK !== null ? 'mk='+appMK+'&' : '');

const appUser = 'demo';
const appKey = 'demo_key';
//const appUser	= urlParams.get('u');
//const appKey	= urlParams.get('key');

const topRightPanel = document.getElementById('top-right-panel');

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

var auth = false;
//const auth = validateUserKey(appUser, appKey);
//console.log(await validateUserKey(appUser, appKey));

validateUserKey(appUser, appKey);

//main();

async function validateUserKey(user, key){
	var response = await getJson(proxyURL + `u=${appUser}&key=${appKey}&r=a`);
	//return response;
	auth = response;
	//console.log(auth);

	if (auth === false){
		alert ('Error[0]: unknown_key');
		throw new Error();
	}
	main();
}



function main(){

	//add Yandex projection, 3395
	const yaex = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244];
	proj4.defs('EPSG:3395', '+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs');
	ol.proj.proj4.register(proj4);
	ol.proj.get('EPSG:3395').setExtent(yaex);


	const center = ol.proj.transform([30.315482, 59.938996], 'EPSG:4326', 'EPSG:3857');


	var map = new Map({
		layers: [
			new TileLayer({
	//			title: 'OSM',
	//			type: 'base',
				//opacity: 0.3,
				visible: true,
				source: new OSM(),
				className: 'ol-basic',
			}),
			
			new TileLayer({
				//minNativeZoom: 10,
				//maxNativeZoom: 16,
				minZoom: 10,
				maxZoom:18,
				//nativeZooms: [10, 16],
				tileSize:256,
				title: 'Tracks',
				visible: false,
				source: new ol.source.XYZ({
					url: proxyURL + 't=T&x={x}&y={y}&z={z}',
					projection: 'EPSG:3395',
					tileGrid: ol.tilegrid.createXYZ({
						extent: yaex
					}),
				}),
				className: 'ol-basic',
			}),
			new TileLayer({
				title: 'Sport',
				visible: false,
				source: new ol.source.XYZ({
					url: proxyURL + 't=S&x={x}&y={y}&z={z}',
				}),
				className: 'ol-basic',
			}),
			new TileLayer({
				title: 'GPS',
				visible: false,
				source: new ol.source.XYZ({
					url: proxyURL + 't=G&x={x}&y={y}&z={z}',
				}),
				className: 'ol-basic',
			}),
			new TileLayer({
				title: 'Phones',
				visible: false,
				source: new ol.source.XYZ({
					url: proxyURL + 't=P&x={x}&y={y}&z={z}',
				}),
				className: 'ol-basic',
			}),
		],
		target: 'map',
		view: new View({
			center: center,
			zoom: 12,
			maxZoom:16,
			//rotation: 1,
		}),
	});

//	const ol3d = new OLCesium({map}); 
//	ol3d.setEnabled(true);

	//===========================================================================================

	const metroSPbLayer = new MetroSPbLayer({
		title: 'метро Санкт-Петербург',
		//html: html,
		visible: true,
		id: 'metroSPb',
	});
	map.addLayer(metroSPbLayer);
	map.addOverlay(metroSPbLayer.overlay);

	//===========================================================================================

	const filters = {
		areaMin: 100,
		areaMax: 300,
		priceMin: 60000,
		priceMax: 300000,
	};

	const avitoLayer = new AvitoLayer({
		title: 'Avito',
		visible: true,
		id: "avitoMain",
		filters: filters,
	});
	map.addLayer(avitoLayer);
	map.addOverlay(avitoLayer.overlay);

	//===========================================================================================

	const layerSwitcher = new CustomLSW({
		target: topRightPanel,
		activationMode: 'click',
		startActive: true,
		renderOnce: true,
		tipLabel: 'Layers', // Optional label for button
		reverse: false,
		groupSelectStyle: 'group',
	});
	map.addControl(layerSwitcher);

	//===========================================================================================

	const serviceControl = new ServiceControl({
		target: topRightPanel,
	});
	map.addControl(serviceControl);

	//===========================================================================================



/* 

	var animationInterval;
	function startAnimation(){
		if(loadingID !== ''){
			animationInterval = setInterval(rotateMarker, 10);
		}
	}
	function stopAnimation(){
		loadingID= '';
		clearInterval(animationInterval);
	}

	function rotateMarker(){
		if(loadingID !== ''){
			rotationRad += Math.PI/36;
			if(rotationRad > 2*Math.PI) rotationRad = 0;
			var feature = avitoLayer.getFeatureByName(loadingID);
			feature.setStyle(feature.styleFunc);
	//		var style = feature.getStyle();
	//		console.log(feature);
		}
	}

 */


	//=================================== /* EVENTS */ ==========================================
	map.on('moveend', onMoveEnd);
	function onMoveEnd(evt) {
		const mvp = getMapRegion(evt.map);

		avitoLayer.loadMarkers(mvp);
	}


	function wrapLon(value) {
		const worlds = Math.floor((value + 180) / 360);
		return value - worlds * 360;
	}
	function getMapRegion(map){
		var mvp = [];
		const extent = map.getView().calculateExtent(map.getSize());
		const bottomLeft = toLonLat(getBottomLeft(extent));
		const topRight = toLonLat(getTopRight(extent));

		mvp.zoom = Math.round(map.getView().getZoom());
		mvp.latB = bottomLeft[1]-0.2;
		mvp.latT = topRight[1]+0.2;
		mvp.lonL = wrapLon(bottomLeft[0])-0.2;
		mvp.lonR = wrapLon(topRight[0])+0.2;

		return mvp;
	}





	map.on('pointermove', function(evt) {
		//var hasFeature = map.hasFeatureAtPixel(evt.pixel);
		//map.getTargetElement().style.cursor = hasFeature ? 'pointer' : '';
		//if (!hasFeature) avitoLayer.hoverUnset();
		avitoLayer.hoverUnset();
		metroSPbLayer.hoverUnset();

		var firstTime = true;
		var isFeature = map.forEachFeatureAtPixel(evt.pixel, function(feature,layer) {
			var layerID = layer.get('id');
			if((layerID !== undefined)&&(firstTime)){
				if (typeof layer.hoverFunc === "function") {
					layer.hoverFunc(feature);
				}
				firstTime = false;
			}
		});
		
		
		
		if (!isFeature) {
			//container.style.opacity=0;
		}
	});



	map.on('singleclick', function(evt) {
		var isFeature = map.forEachFeatureAtPixel(evt.pixel, function(feature,layer) {
			var layerID = layer.get('id');
			if(layerID !== undefined){
				layer.clickFunc(feature);
				return layerID || true;
			} else {
				console.log('undefined layer');
			}
		});
		//console.log(isFeature);
		
		if (isFeature === undefined) {
			avitoLayer.clickUnset();
			metroSPbLayer.clickUnset();
		}
	});


}
